<template>
    <div class="install-certificates">
        <div class="container">
            <BackButton class="accent" />

            <div class="header">Установите российские сертификаты для стабильного доступа к порталу</div>

            <div class="content">
                <div class="text">
                    Портал Территория цифровых решений
                    будет работать с применением сертификатов НУЦ Минцифры РФ — это необходимо, поскольку работа многих
                    браузеров с иностранными сертификатами ограничена. Установите новые сертификаты на ваше устройство,
                    чтобы обеспечить надёжное и защищённое подключение, которое позволит всегда иметь доступ к порталу.
                </div>
                <div class="text">
                    Вы также можете пользоваться Яндекс.Браузером, в который по умолчанию встроена
                    поддержка российских сертификатов. Убедитесь, что у вас стоит актуальная версия Яндекс.Браузера.
                </div>

            </div>
            <div class="decisions">
                <div class="card">
                    <div class="icon gosuslugi" />
                    <div class="info">
                        <div class="title">
                            Установите сертификаты и используйте любой браузер. Вам поможет инструкция
                            на Госуслугах
                        </div>

                        <button class="action" @click="openGosuslugi">Установить сертификаты</button>
                    </div>
                </div>

                <div class="card">
                    <div class="icon yandex" />
                    <div class="info">
                        <div class="title">
                            Скачайте и используйте Яндекс.Браузер с поддержкой российских сертификатов
                        </div>

                        <button class="action" @click="openYandex">Скачать браузер</button>
                    </div>
                </div>

            </div>

        </div>

    </div>
</template>

<script>
export default {
    name: 'InstallCertificates',
    methods: {
        openGosuslugi() {
            window.open('https://www.gosuslugi.ru/crt', '_blank');
        },
        openYandex() {
            window.open('https://browser.yandex.ru/', '_blank');
        },
    },
};
</script>

<style lang="scss" scoped>
@import "@dsee/mixins.scss";

.install-certificates {
    min-height: 100vh;
    background: #FFFFFF url('./icons/bg.png') no-repeat;
    background-position: right top;
    background-size: contain;

    @media (max-device-width: 767px) {
        padding-top: 30px;
    }

    .container {
        display: flex;
        flex-flow: column;
        margin: 0 10vw;
        padding-top: 20vh;
        padding-bottom: 10vh;
        box-sizing: border-box;
    }

    .header {
        font-weight: 700;
        font-size: 26px;
        line-height: 36px;
        color: #000000;
        margin-bottom: 32px;
        margin-top: 32px;
    }

    .content {
        max-width: 850px;
    }

    .text:not(:first-child) {
        margin-top: 32px;
    }

    .decisions {
        margin-top: 32px;
        display: flex;
        gap: 20px;

        @media (max-device-width: 767px) {
            flex-direction: column;
        }

        .card {
            display: inline-flex;
            max-width: 406px;
            width: 100%;
            padding: 20px;
            border-radius: 20px;
            border: var(--input-border);

            .icon {
                flex: none;
                background-position: center center;
                background-repeat: no-repeat;
                background-size: contain;
                @include icon(60px, 60px);
                margin-right: 16px;

                &.gosuslugi {
                    background-image: url('./icons/gosuslugi.png');
                }

                &.yandex {
                    background-image: url('./icons/yandex.png');
                }

            }

            .title {
                color: #000000;
                margin-bottom: 20px;
            }

            .action {
                padding: 8px 20px;
            }
        }
    }

}
</style>
